<template lang='html'>
  <v-form ref="form" v-model='valid'>
    <div class='url-path-input'>
      <span v-if='!valid'>
        <v-alert
          text
          dense
          color="#e0255e"
          icon="info"
          border="left"
          class='not-valid-message'
        >
          {{ $t('path.not.valid.message') }}
        </v-alert>
      </span>
      <div class='protocol-section'>
        <span class='label'> {{ $t('test.select.protocol.label') }} </span>
        <div class='input-row-section'>
          <v-autocomplete
            :items="typesOfProtocols"
            v-model="internalValue.advancedOptions.protocol"
            :rules="[rules.required]"
            :placeholder="$t('test.select.protocol.placeholder')"
            item-text='title'
            item-value='value'
            dense
            outlined
            autofocus
            allow-overflow
            append-icon="expand_more"
            height="20"
          />
          <custom-tooltip class='tool-tip-hint' placement="bottom" popper-class="light-tooltip">
            <div slot='buttonContent'>
              <span class="material-icons-outlined">
                info
              </span>
            </div>
            <div slot="content">
              <slot name="tooltip">
                <span class='tooltip-text'>{{ toolTipTextByInputType.protocol }}</span>
              </slot>
            </div>
          </custom-tooltip>
        </div>
      </div>
      <div class='path-section'>
        <span class='label'> {{ $t('test.url.path.label') }} </span>
        <div class='input-row-section'>
          <text-field
            :rules='[rules.required, rules.urlPath]'
            v-model='internalValue.advancedOptions.path'
            :placeholder="$t('test.url.path.placeholder').toString()"
          />
          <custom-tooltip class='tool-tip-hint' placement="bottom" popper-class="light-tooltip">
            <div slot='buttonContent'>
              <span class="material-icons-outlined">
                info
              </span>
            </div>
            <div slot="content">
              <slot name="tooltip">
                <span class='tooltip-text'>{{ toolTipTextByInputType.path }}</span>
              </slot>
            </div>
          </custom-tooltip>
        </div>
      </div>
      <div class='port-section'>
        <span class='label'> {{ $t('test.url.path.port.label') }} </span>
        <div class='input-row-section'>
          <v-autocomplete
            :items="portsItems"
            v-model="internalValue.advancedOptions.port"
            :rules="[rules.portNotRequired]"
            @input.native="handlePortInput"
            :placeholder="$t('test.url.port.placeholder')"
            dense
            outlined
            autofocus
            return-object
            allow-overflow
            append-icon="expand_more"
            height="20"
          />
          <custom-tooltip class='tool-tip-hint' placement="bottom" popper-class="light-tooltip">
            <div slot='buttonContent'>
              <span class="material-icons-outlined">
                info
              </span>
            </div>
            <div slot="content">
              <slot name="tooltip">
                <span class='tooltip-text'>{{ toolTipTextByInputType.port }}</span>
              </slot>
            </div>
          </custom-tooltip>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import TextField from '@/components/common/TextField.vue';
import { rules } from '@/utils/validationUtils';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'UrlPathInput',
  props: {
    value: Object,
    portsToSuggest: Array,
  },
  data() {
    return {
      portInputValue: '',
      valid: false,
    };
  },
  watch: {
    valid() {
      this.updateValid();
    },
  },
  methods: {
    handlePortInput(event) {
      this.portInputValue = event.target.value;
    },
    updateValid() {
      this.$emit('updateValid', this.valid);
    },
  },
  components: { TextField, CustomTooltip },
  computed: {
    toolTipTextByInputType() {
      return {
        port: this.$t('test.select.port.tooltip'),
        protocol: this.$t('test.select.protocol.tooltip'),
        path: this.$t('test.select.path.tooltip'),
      };
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    portsItems() {
      const items = (this.portInputValue
        ? [this.portInputValue]
        : []
      ).concat([...this.portsToSuggest]);
      return items;
    },
    rules() {
      return rules;
    },
    typesOfProtocols() {
      return [
        {
          value: 'https',
          title: this.$t('test.select.protocol.https'),
        },
        {
          value: 'http',
          title: this.$t('test.select.protocol.http'),
        },
      ];
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.url-path-input {
  .v-input__icon--append-outer {
    .v-icon {
      margin-bottom: $space-3;
    }
  }
  .v-input {
    margin-top: rem(3);
  }
  .v-input__slot {
    min-height: rem(28);
  }
  .v-alert__icon.v-icon {
    color: $severity-critical;
  }
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.url-path-input {
  margin-top: $space-2;
  margin-bottom: $space-5;
  .tool-tip-hint {
    .tooltip-text {
      font-size: $font-size-xl;
    }
  }
  .input-row-section {
    display: flex;
    align-items: center;
    .material-icons-outlined {
      color: #C0C4CC;
      margin-left: rem(5);
      font-size: $font-size-xl;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .not-valid-message {
    font-size: $font-size-xs;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: $space-4;
  }
  .label {
    text-transform: uppercase;
    color: var(--input-label);
    font-family: $font-family-regular;
    font-size: rem(9);
    letter-spacing: rem(0.8);
    line-height: rem(10);
  }
}
</style>
